import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import WheelModal from "./wheel-modal"
import {ADD_TOAST, addToast, removeModalWindow} from "../../../ducks/duck-screen";
import {spinTheWheel} from "../../../ducks/duck-user";
import {getServerOffset} from "../../../helpers/cloud-function/server-timestamp";
import {addDays, secondsToHMS} from "../../../helpers/date";
import {getTranslation} from "../../../helpers/get-translation";
import {playWinnerWheelAudio} from "../../../helpers/sounds";

class WheelModalContainer extends Component {
	state = {
		angle: 0,
		winningAngle: null,
		winAmount: null,
		isSpinning: false,
		hasStoppedSpinning: false,
		serverTimestampOffset: null,
		countDownText: ""
	};
	isComponentMounted;
	wheelInterval = null;
	timeInterval = null;

	spinWheel = () => {
		if(this.state.isSpinning){
			return
		}
		this.setState({ isSpinning: true });
		let angleHasReachedEqualZero = true;
		let iterationCount = 0;
		const DEFAULT_SPIN_INCREMENT = 20;
		this.props.spinTheWheel(this.winCallback, this.failCallback);
		this.wheelInterval = setInterval(() => {
			const winningAngle = this.state.winningAngle;
			const angle = this.state.angle;
			if(winningAngle !== null && angleHasReachedEqualZero){
				iterationCount++;
				const angleDifference = Math.floor(winningAngle - angle);
				const base = 1.015 + (0.0002 * iterationCount);
				const angleIncrement = Math.min(DEFAULT_SPIN_INCREMENT, base ** angleDifference);
				const newAngle = Math.round(angle + angleIncrement);
				console.log(base, angleIncrement);

				this.setStateIfComponentMounted({angle: newAngle});

				if(newAngle === winningAngle){
					setTimeout(() => {
						playWinnerWheelAudio();
						this.setStateIfComponentMounted({hasStoppedSpinning: true, isSpinning: false});
					}, 350);
					clearInterval(this.wheelInterval)
				}
			} else {
				const newAngle = (angle + DEFAULT_SPIN_INCREMENT) % 360;
				angleHasReachedEqualZero = newAngle === 0;
				this.setStateIfComponentMounted({angle: newAngle});
			}
		}, 50)
	};

	winCallback = (angle, multiplier) => {
		this.setStateIfComponentMounted({winningAngle: 360 + angle, winAmount: multiplier});
	};

	failCallback = () => {
		if(this.isComponentMounted) {
			this.props.removeModalWindow();
			this.props.addToast("modal_wheel_come_back_tomorrow");
			clearInterval(this.wheelInterval);
		}
	};

	setStateIfComponentMounted = (state) => {
		if(this.isComponentMounted) {
			this.setState(state)
		} else {
			console.log("aaaaaaaaaaaaaa", state)
		}
	};

	componentDidMount(){
		this.isComponentMounted = true;

		getServerOffset()
			.then(offset => {
				this.setState({ serverTimestampOffset: offset });

				if(!this.canUserSpinTheWheel(this.props.lastSpinOfWheel, offset)){
					this.timeInterval = setInterval(() => {
						const seconds = this.calculateSecondsToNextSpin(this.props.lastSpinOfWheel, this.state.serverTimestampOffset);
						const time = secondsToHMS(seconds);

						if(seconds < 1){
							clearInterval(this.timeInterval);
							this.unlockTheWheel();
							this.timeInterval = null
						}

						const text = getTranslation("modal_wheel_time_text", time);
						this.setState({ countDownText: text })
					}, 1000)
				}
			})
	}

	calculateSecondsToNextSpin(lastSpinOfWheel, serverTimestampOffset) {
		const lastSpin = new Date(lastSpinOfWheel - serverTimestampOffset);
		const nextSpin = addDays(lastSpin, 1);

		const difference =  nextSpin.getTime() - Date.now() - serverTimestampOffset;
		return difference / 1000
	}

	unlockTheWheel(){
		setTimeout(() => {
			this.forceUpdate()
		}, 1000)
	}

	canUserSpinTheWheel(lastSpinOfWheel, serverTimestampOffset){
		if(lastSpinOfWheel === undefined || serverTimestampOffset === null){
			return true
		}

		const lastSpin = new Date(lastSpinOfWheel - serverTimestampOffset);
		const lastSpinPlusOneDay =  addDays(lastSpin, 1);
		const now = new Date(Date.now() - serverTimestampOffset);

		return now >= lastSpinPlusOneDay;
	}

	componentWillUnmount() {
		this.isComponentMounted = false;

		if(this.wheelInterval !== null){
			clearInterval(this.wheelInterval);
			this.wheelInterval = null;
		}
		if(this.timeInterval !== null){
			clearInterval(this.timeInterval);
			this.timeInterval = null;
		}

		const winAmount = this.state.winAmount;
		console.log(this.state.isSpinning);
		console.log(winAmount);
		if(this.state.isSpinning && winAmount !== null){
			if(winAmount === 1){
				this.props.addToast("modal_wheel_win_toast_text_singular");
			} else {
				this.props.addToast("modal_wheel_win_toast_text_plural", 5000, [winAmount]);
			}
		}
	}


	render(){
		const canSpin = this.canUserSpinTheWheel(this.props.lastSpinOfWheel, this.state.serverTimestampOffset);

		return (
			<WheelModal
				{...this.props}
				winAmount={this.state.winAmount}
				isSpinning={this.state.isSpinning}
				hasStoppedSpinning={this.state.hasStoppedSpinning}
				countDownText={this.state.countDownText}
				canSpin={canSpin}
				spinWheel={this.spinWheel}
				angle={this.state.angle}/>
		)
	}
}

WheelModalContainer.propTypes = {
	lastSpinOfWheel: PropTypes.instanceOf(Date),

	removeModalWindow: PropTypes.func.isRequired,
	addToast: PropTypes.func.isRequired,
	testAddToast: PropTypes.func.isRequired,
	spinTheWheel: PropTypes.func.isRequired,
};

function mapStateToProps(state){
	return {
		lastSpinOfWheel: state.userReducer.user.lastSpinOfWheel
	}
}


export default connect(
	mapStateToProps,
	{
		removeModalWindow,
		addToast,
		spinTheWheel,
		testAddToast: (string) => {
			return {
				type: ADD_TOAST,
				payload: {
					toast: {
						message: string,
						timeout: 2000
					}
				}
			};
		}
	}
)(WheelModalContainer);
